import { render } from "./statusCard.vue?vue&type=template&id=470af248&scoped=true"
import script from "./statusCard.vue?vue&type=script&lang=js"
export * from "./statusCard.vue?vue&type=script&lang=js"

import "./statusCard.vue?vue&type=style&index=0&id=470af248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470af248"]])

export default __exports__